function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 8,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.554 16.512l.223-.22v-4.406 0c0-1.471.648-2.879 1.787-3.86h0a5.289 5.289 0 014.139-1.23h0c2.563.333 4.52 2.59 4.52 5.273v4.223l.224.22 1.601 1.579h0a.66.66 0 01.149.735h0a.699.699 0 01-.651.424H7.454a.701.701 0 01-.653-.425.661.661 0 01.15-.734s0 0 0 0l1.602-1.579zM16 20a2 2 0 11-4 0",
  stroke: "#000",
  strokeWidth: 1.5
});

function SvgNotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgNotify;